var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score"},[_c('div',{staticClass:"container"},[(_vm.gameData != null)?_c('div',[_c('Summary',{attrs:{"summary":_vm.gameData}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }